import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenService } from '@pacifico/services/api/token.service';
import { PATHS_AUTH_PAGES } from '@pacifico/utils/path-page';

@Injectable({ providedIn: 'root' })
export class DashboardGuard implements CanActivate {
	constructor(private _tokenService: TokenService, private _router: Router) {}
	canActivate(): boolean {
		if (!this._tokenService.isLoggedIn()) {
			void this._router.navigateByUrl(PATHS_AUTH_PAGES.loginPage.withSlash);
			return false;
		}
		return true;
	}
}
